import { Link } from "react-router-dom";
import { Badge as KindBadge } from "@steelyard/theme";
import { Alert } from "rizzui";

/** Ported from apps/admin/components/customer-tally-link.tsx. "Not linked" is normal, not a failure. */
export function CustomerTallyLink({ linked, divergesFromAccounting = false }: { linked: boolean; divergesFromAccounting?: boolean }) {
  return (
    <div className="flex flex-col gap-3">
      {linked ? (
        <p className="flex flex-wrap items-center gap-2 text-sm">
          <KindBadge kind="active">Linked</KindBadge>
          This customer has a ledger in the accounting system.
        </p>
      ) : (
        <p className="text-sm">
          <strong>Not linked, and that is normal.</strong> A Tally ledger is created on this customer&apos;s first
          successful order, not when they register (BR-10). Nothing is wrong and nothing needs doing.
        </p>
      )}
      {divergesFromAccounting ? (
        <div role="alert">
          <Alert color="warning" variant="flat">
            This record diverges from the accounting record after a local override. It is listed on the{" "}
            <Link to="/customers/dedupe" className="underline">
              duplicate records report
            </Link>
            .
          </Alert>
        </div>
      ) : null}
    </div>
  );
}
